const stripWhitespace = (str) => {
  return str.split(' ').join('')
}

export default stripWhitespace
